import { Component, type ReactNode } from "react";

type State = { error: Error | null };

export default class RouteErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    if (typeof console !== "undefined") {
      console.error("[RouteErrorBoundary]", error);
    }
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
          <h1 className="text-xl font-semibold text-gray-900 mb-2">Something went wrong on this page</h1>
          <p className="text-sm text-gray-500 max-w-md mb-6">
            The rest of the app is fine — only this view crashed. Try going back, or reload the page.
          </p>
          <div className="flex items-center gap-3">
            <button
              onClick={() => window.history.back()}
              className="px-4 py-2 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50"
            >
              Go back
            </button>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-lg bg-navy text-white text-sm font-semibold hover:bg-navy-light"
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
